import { useFormContext } from 'react-hook-form';

import { Typography, Space } from '@sravni/react-design-system';
import { Edit } from '@sravni/react-icons';
import {
  OTPInput,
  GetOTPLink,
  ServerErrorMessage,
  SubmitButton,
  useBehaviourState,
  PhoneInput,
} from '@sravni/react-silent-authentication-form';

import { AUTH_SCREEN_NAME } from 'entities/Authentication/config/screenName';
import { AuthenticationTexts } from 'entities/Authentication/config/texts';
import type { AuthScreenProps } from 'entities/Authentication/types';

export function AuthOtpScreen({ updateScreen, content }: AuthScreenProps) {
  const formState = useFormContext();
  const { isLoading } = useBehaviourState();

  const handleEditPhone = () => {
    updateScreen(AUTH_SCREEN_NAME.INITIAL);
    formState.resetField('phone', { defaultValue: '' });
  };

  return (
    <>
      <Typography.Heading level={5} size={16}>
        {AuthenticationTexts.OtpScreen.title}
      </Typography.Heading>
      <PhoneInput icon={<Edit onClick={handleEditPhone} />} />

      <OTPInput />
      <GetOTPLink />

      <ServerErrorMessage />
      <Space direction="row" align="center" size={8} justify="space-between">
        <div>{content}</div>
        <div>
          <SubmitButton size={44} loading={isLoading}>
            {AuthenticationTexts.OtpScreen.buttonText}
          </SubmitButton>
        </div>
      </Space>
    </>
  );
}
